import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from "@tanstack/react-query";
import {
  type EnterpriseAssetsV2RequestOptions,
  fetchEnterpriseAssetsV2Table,
} from "../api/enterpriseClient";

export const DEFAULT_ASSETS_V2_REQUEST_OPTIONS = {
  riskType: "all",
  sortBy: "daysOpen",
  sortDirection: "desc",
  page: 1,
  pageSize: 25,
} as const;

export const assetsV2TableQueryOptions = (
  customerId: number,
  options: EnterpriseAssetsV2RequestOptions = {},
) => {
  const resolvedOptions = {
    ...DEFAULT_ASSETS_V2_REQUEST_OPTIONS,
    ...options,
  };
  return queryOptions({
    queryKey: ["enterprise-assets-v2-table", customerId, resolvedOptions],
    queryFn: () => fetchEnterpriseAssetsV2Table(customerId, resolvedOptions),
    staleTime: 60_000,
  });
};

export function useGetAssetsV2Table(
  customerId: number,
  options: EnterpriseAssetsV2RequestOptions = {},
  settings: { keepPreviousData?: boolean } = {},
) {
  const query = assetsV2TableQueryOptions(customerId, options);
  return useQuery({
    ...query,
    ...(settings.keepPreviousData ? { placeholderData: keepPreviousData } : {}),
  });
}
